import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
html {
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
  &:lang(en){
    font-family: Poppins, sans-serif ;
    line-height:1.5;
  }
  &:lang(ko){
    font-family:  Pretendard, sans-serif ;
    line-height:1.5;
  }

   /* 스크롤바의 전체 영역 스타일 */
  ::-webkit-scrollbar {
    width: 6px;
  }

  /* 스크롤바의 막대 스타일 */
  ::-webkit-scrollbar-thumb {
    border-radius: 4px !important;
    background: ${({ theme }) => theme.color.buttons.default} !important;
    border: 2px solid transparent;
    background-clip: padding-box;
  }
}

.dds-icon {
  display: inline-flex;
}


*,
*:before,
*:after {
  box-sizing: inherit;
}

html, body {
  color: ${(props) => props.theme.color.mainFont};
  word-break: keep-all;
  /* 아이폰 이미지 저장 방지 */
}

.editor-bubble {

}

html:lang(ko-KR) body {
  font-family: Pretendard, sans-serif;
}

html,
body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
ol,
ul,
dl,
dt,
dd,
button,
input,
pre {
  margin: 0;
  padding: 0;
}

body{
    #root {
      position: absolute;
      width: 100%;  
    }
}

ol,
ul {
  list-style: none;
}

a,
a:hover {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}

button,
[type="button"],
[type="reset"],
[type="submit"] {  
  -webkit-appearance: button;
}

input[type='radio'] {
  -webkit-appearance: radio;
}

button {
  color: inherit;
  font-family: inherit;
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  &:disabled{
    cursor: not-allowed;
  }
}

input, textarea, select{
  font-family: inherit !important;
  border: 0;
  background: transparent;
  -webkit-appearance: none;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  transition: background-color 5000s ease-in-out 0s;
  -webkit-transition: background-color 9999s ease-out;
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
  font-family: inherit !important;
}

input::-webkit-autofill::first-line {
  font-family: inherit !important;
  font-size: inherit !important;
}

// safari에서 disabled input, textarea text color 설정용
input:disabled, textarea:disabled, input:disabled::placeholder, textarea:disabled::placeholder {
  -webkit-text-fill-color: #bcbcbc; 
  opacity: 1;
}

img {
  -webkit-touch-callout:none;  
  -webkit-user-select: none; /* iOS Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}


.mt-20{
  margin-top: 20px;
}
.mb-20{
  margin-bottom: 20px;
}

.mb-30{
  margin-bottom: 30px;
}

.ml-10{
  margin-left: 10px;
}

.sub-font {
  color: ${({ theme }) => theme.color.subfontgray};
}

.flex-center-center{
  display: flex;
  justify-content: center;
  align-items: center;
}

.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.ellipsis-two-line {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;

  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: wrap;
}

.drag-selectable {
  user-select: all;
  /* user-select: text; 경우 이미지 선택, cmd(ctl)+c 복사가 가능하므로 사용하지 않음.*/
}

.cursor-disabled{
  cursor: not-allowed !important;
}

`;
